if (!customElements.get('subcategory-nav')) {
  customElements.define(
    'subcategory-nav',
    class SubcategoryNav extends HTMLElement {
      constructor() {
        super();
        this.pills = this.querySelectorAll('.subcategory-nav__pill');
        this.titleTextElement = this.querySelector('.subcategory-nav__title-text');
        this.countElement = this.querySelector('.subcategory-nav__count');
        this.collectionTitle = this.dataset.collectionTitle;
        this.collectionCount = this.dataset.collectionCount;
        this.bindEvents();
        this.observeProductCount();
        this.scrollActivePillIntoView();
      }

      scrollActivePillIntoView() {
        const scroller = this.querySelector('.subcategory-nav__pills');
        const activePill = this.querySelector('.subcategory-nav__pill[aria-current]');
        if (!scroller || !activePill) return;

        // Scroll only the pill list horizontally (scrollIntoView would also scroll the page)
        const offset = activePill.getBoundingClientRect().left - scroller.getBoundingClientRect().left;
        scroller.scrollLeft += offset - (scroller.clientWidth - activePill.offsetWidth) / 2;
      }

      bindEvents() {
        this.pills.forEach((pill) => {
          pill.addEventListener('click', this.onPillClick.bind(this));
        });

        window.addEventListener('popstate', this.onPopState.bind(this));
      }

      observeProductCount() {
        const productCountEl = document.getElementById('ProductCount');
        if (!productCountEl || !this.countElement) return;

        const observer = new MutationObserver(() => {
          this.syncCount();
        });

        observer.observe(productCountEl, { childList: true, characterData: true, subtree: true });
      }

      syncCount() {
        const productCountEl = document.getElementById('ProductCount');
        if (!productCountEl || !this.countElement) return;

        const countText = productCountEl.textContent.trim();
        const match = countText.match(/\d+/);
        if (match) {
          this.countElement.textContent = match[0];
        }
      }

      onPillClick(event) {
        const pill = event.currentTarget;
        const targetUrl = new URL(pill.href, window.location.origin);
        const currentUrl = new URL(window.location.href);

        // If navigating to a different collection (different pathname), do full page navigation
        if (targetUrl.pathname !== currentUrl.pathname) {
          // Let the browser handle normal link navigation
          return;
        }

        // Same collection - use AJAX filtering
        event.preventDefault();
        const searchParams = targetUrl.search.slice(1);

        if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
          FacetFiltersForm.renderPage(searchParams, null, true);
        } else {
          window.location.href = pill.href;
          return;
        }

        this.updateActiveState(pill);
        this.updateTitle(pill);
      }

      onPopState() {
        const params = new URLSearchParams(window.location.search);
        const activeTag = params.get('filter.p.tag');

        this.pills.forEach((pill) => {
          const pillHandle = pill.dataset.subcategoryHandle;
          const isAll = pill.hasAttribute('data-subcategory-all');
          const isActive = (activeTag === null && isAll) || (activeTag === pillHandle);

          pill.querySelector('.kt-button')?.classList.toggle('kt-button--active', isActive);
          if (isActive) {
            pill.setAttribute('aria-current', 'true');
            this.updateTitle(pill);
          } else {
            pill.removeAttribute('aria-current');
          }
        });
      }

      updateActiveState(activePill) {
        this.pills.forEach((pill) => {
          pill.querySelector('.kt-button')?.classList.remove('kt-button--active');
          pill.removeAttribute('aria-current');
        });
        activePill.querySelector('.kt-button')?.classList.add('kt-button--active');
        activePill.setAttribute('aria-current', 'true');
      }

      updateTitle(pill) {
        if (!this.titleTextElement) return;

        const isAll = pill.hasAttribute('data-subcategory-all');
        if (isAll) {
          this.titleTextElement.textContent = this.collectionTitle;
        } else {
          this.titleTextElement.textContent = pill.dataset.subcategoryTitle;
        }
      }

    }
  );
}
